import {
  getCookieValueFromHeader,
  getLangFromSearch,
  LANG_PROP_NAME,
  parseLangCookieRaw,
  resolveLocale,
  type UserReturnDto,
} from '@skillarea/lib-shared';
import {
  getBrowserLocale,
  getLangQueryParam,
  parseLangCookieFromDocument,
} from '@skillarea/lib-frontend';

export function resolveLocaleFromRequest(
  request: Request,
  user: UserReturnDto | null,
): string {
  const cookieRaw = getCookieValueFromHeader(
    request.headers.get('Cookie'),
    LANG_PROP_NAME,
  );
  const url = new URL(request.url);

  return resolveLocale({
    queryLang: getLangFromSearch(url.search) ?? undefined,
    cookieLang: parseLangCookieRaw(cookieRaw),
    userLang: user?.lang,
  });
}

export function resolveClientLocale(user: UserReturnDto | null): string {
  return resolveLocale({
    queryLang: getLangQueryParam() ?? undefined,
    cookieLang: parseLangCookieFromDocument(),
    userLang: user?.lang,
    browserLocale: getBrowserLocale(),
  });
}

export {
  getBrowserLocale as getClientBrowserLocale,
  parseLangCookieFromDocument,
};
